class Lang {

    set(lang) {
        if (lang != this.get()) localStorage.setItem('lang', lang);
        document.cookie = "locale="+lang+"; path=/";
    }

    get() {
        if (!localStorage.getItem('lang')) localStorage.setItem('lang', 'he')
        return localStorage.getItem('lang');
    }

}

export default Lang = new Lang()
